import React, { Component } from 'react'
import withRouter from '../lib/withRouter';
import { connect } from 'react-redux';
import Authentication from '../../session';
import Service from '../services'
import { BasicLazyParams } from '../../utile';
import BranchToSectionMultiDDTillSecReports from '../BaseDropdownComponents/BranchToSectionMultiDDTillSecReports';
import { getBranchesLatest } from '../../store/actions';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import './styles.scss'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { baseUrlAdmin } from '../../store/apiConstants';
import { Toast } from 'primereact/toast';
import moment from 'moment';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import ClassetCalendar from '../../classetComponents/classetCalender';
import { Button } from 'primereact/button';
import * as XLSX from 'xlsx';

class StudentStatusChangeReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            lazyParams: BasicLazyParams,
            filteredUsers: [],
            selectedStudents: [],
            status: null,
            dateRange: null,
        }
        this.service = new Service()
    }
    setDropdownValues = (dropdownsData) => {
        const branchChanged = this.state.dropdownsData?.branchIds !== dropdownsData.branchIds;
        this.setState({
            dropdownsData,
            branchChanged,
            studentsList: [],
            selectedStudents: [],
            dateRange: null
        }, () => {
            if (this.state.dropdownsData?.sectionIds?.length > 0) {
                this.filtersUsersData()
            }

        });
    }
    handleStudentChange = (e) => {
        this.setState({
            selectedStudents: e.value
        }, () => {
            this.filtersUsersData(false);
        });
    }
    handleDateRangeChange = (e) => {
        this.setState({
            dateRange: e.value
        }, () => {
            this.filtersUsersData(false);
        });
    }
    filtersUsersData = (isSelectedStudent = true) => {
        const { users, dropdownsData, lazyParams, selectedStudents, dateRange } = this.state;
        let filteredUsers = users?.filter((user) => {
            const statusChangeDate = user.handledBy[user.handledBy.length - 1]?.handledDate;

            // Check date range if selected
            if (dateRange && dateRange[0] && dateRange[1]) {
                const changeDate = moment(statusChangeDate).format('YYYY-MM-DD');
                const startDate = moment(dateRange[0]).format('YYYY-MM-DD');
                const endDate = moment(dateRange[1]).format('YYYY-MM-DD');

                if (changeDate < startDate || changeDate > endDate) {
                    return false;
                }
            }

            if (selectedStudents?.length > 0 && !selectedStudents.includes(user.user_id)) {
                return false;
            }
            if (dropdownsData?.sectionIds?.length > 0 && !dropdownsData.sectionIds.includes(user.sectionId)) {
                return false;
            }
            return true;
        });

        const first = lazyParams.first || 0;
        const rows = lazyParams.rows || 10;
        const paginatedUsers = filteredUsers?.slice(first, first + rows);


        let studentsFilter;
        if (isSelectedStudent) {

            studentsFilter = filteredUsers?.filter(user => {
                return ({
                    user_id: user?.user_id,
                    studentName: `${user?.firstName} ${user?.lastName}`
                })

            }).map((user) => ({
                user_id: user?.user_id,
                studentName: `${user?.firstName} ${user?.lastName}`
            }));
        }

        this.setState({
            filteredUsers: paginatedUsers,
            totalRecords: filteredUsers?.length || 0,
            studentsList: studentsFilter || this.state.studentsList,
        });
    }
    fetchUsersData = () => {
        let academicYear = localStorage.getItem("userAcademicYear")
        const url = `${baseUrlAdmin}/studentReports/statusInfo`;
        let payload = {
            academicYear
        }
        this.setState({ isLoading: true })
        this.service.post(url, payload, true).then(res => {
            if (res && res.status && res.res.status) {
                this.setState({
                    isLoading: false,
                    users: res.res.data,
                    totalRecords: res.res.totalRecords
                }, () => this.filtersUsersData());
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
            console.log(e);
        })
    }
    onPage = (event) => {
        this.setState((prevState) => {
            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, () => {
            this.filtersUsersData();
        });
    }

    exportToExcel = () => {
        const { users, dropdownsData, selectedStudents, dateRange } = this.state;

        // Get complete filtered data without pagination
        let completeFilteredData = users?.filter((user) => {
            const statusChangeDate = user.handledBy[user.handledBy.length - 1]?.handledDate;

            if (dateRange && dateRange[0] && dateRange[1]) {
                const changeDate = moment(statusChangeDate).format('YYYY-MM-DD');
                const startDate = moment(dateRange[0]).format('YYYY-MM-DD');
                const endDate = moment(dateRange[1]).format('YYYY-MM-DD');

                if (changeDate < startDate || changeDate > endDate) {
                    return false;
                }
            }

            if (selectedStudents?.length > 0 && !selectedStudents.includes(user.user_id)) {
                return false;
            }
            if (dropdownsData?.sectionIds?.length > 0 && !dropdownsData.sectionIds.includes(user.sectionId)) {
                return false;
            }
            return true;
        });

        // Format data for export
        const exportData = completeFilteredData.map(user => ({
            'Student Name': `${user.firstName} ${user.lastName}`,
            'Enrollment No.': user.username.slice(3),
            'Branch': user.branchName,
            'Board': user['custom:board'],
            'Class': user['custom:grade'],
            'Section': user.sectionName,
            'Previous Status': user.status,
            'Status Change Date': moment(user.handledBy[user.handledBy.length - 1]?.handledDate).format("DD-MM-YYYY"),
            'New Status': user.status === 'Active' ? 'InActive' : 'Active',
            'Reasons For Status Change': user.statusChangeRemarks,
            'Approved By': user.handledBy[user.handledBy.length - 1]?.userName.slice(3)
        }));

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Status Changes");

        // Generate and download file
        XLSX.writeFile(workbook, `Student_Status_Changes_${moment().format('DD-MM-YYYY')}.xlsx`);
    }

    componentDidMount() {
        this.fetchUsersData();

    }

    render() {
        return (
            <>

                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        padding: '0',
                        marginLeft: "100px",
                        marginTop: "55px",
                        overflow: 'auto',

                    }}>
                    <div className="card filters-card mt-1 pt-0">
                        <BranchToSectionMultiDDTillSecReports setValues={this.setDropdownValues} />
                        <div className="grid my-2">
                            <div className='col-3'>
                                <p className='filter-title'>Student Name/Enrollment Number</p>
                                <ClassetMultiSelect
                                    options={this.state.studentsList}
                                    value={this.state.selectedStudents}
                                    optionValue='user_id'
                                    optionLabel='studentName'
                                    onChange={this.handleStudentChange}
                                    placeholder={(
                                        <div>
                                            <span className=''>Select Student</span>
                                        </div>
                                    )}
                                />
                            </div>
                            <div className='col-3'>
                                <p className='filter-title'>Date</p>
                                <ClassetCalendar
                                    selectionMode={'range'}
                                    readOnlyInput
                                    value={this.state.dateRange}
                                    // tooltipInfo={
                                    //     <div>
                                    //         {/* <p className="font-semibold text-sm">Pick From and To Dates</p>
                                    //         <p className="-mt-1">Enter the start and end dates</p> */}
                                    //     </div>
                                    // }
                                    onChange={this.handleDateRangeChange}
                                    placeholder="Select a date"
                                />
                            </div>

                            <div className="col-3 mt-5 flex justify-content-end align-items-center gap-5 ms-auto" style={{ maxWidth: 'fit-content' }}>
                                <Button
                                    label="Download Report"
                                    onClick={this.exportToExcel}
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#F4F5F6", color: "#000" }}
                                />
                                <Button label="View Analysis" className="p-button-primary"
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#076EFF", color: "#fff", }} />
                            </div>
                        </div>
                    </div>

                    <div className="datatable-report-demo mx-2">
                        <DataTable
                            value={this.state.filteredUsers}
                            responsiveLayout="scroll"
                            dataKey="id"
                            paginator
                            lazy
                            onPage={this.onPage}
                            resizableColumns
                            first={this.state.lazyParams.first}
                            last={this.state.totalRecords}
                            rows={this.state.lazyParams.rows}
                            totalRecords={this.state.totalRecords}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            globalFilter={this.state.globalFilter}
                            rowClassName={() => 'table-row-style'}
                        >
                            <Column
                                field="code"
                                header="Student Name"
                                body={(rowData) => {
                                    const formatName = (name) => {
                                        return name
                                            ? name.toLowerCase().split(' ')
                                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                .join(' ')
                                            : '';
                                    };
                                    const firstName = formatName(rowData.firstName);
                                    const lastName = formatName(rowData.lastName);
                                    return <p className="m-0">{`${firstName} ${lastName}`}</p>;
                                }}
                            />
                            <Column
                                header="Enrollment No."
                                body={(rowData) => (
                                    <p className="m-0">{`${(rowData.username).slice(3)}`}</p>
                                )}
                            />
                            <Column header="Branch" field='branchName'></Column>
                            <Column header="Board" field='custom:board'></Column>
                            <Column header="Class" field='custom:grade'></Column>
                            <Column header="Section" field='sectionName'></Column>
                            <Column
                                header="Previous Status"
                                field='status'
                                body={(rowData) => (
                                    <div className={`status-badge ${rowData.status === 'Active' ? 'active' : 'inactive'}`}>
                                        {rowData.status}
                                    </div>
                                )}
                            />
                            <Column header="Status Change Date" field='' body={(rowData) => {
                                return (
                                    <>
                                        <p>{moment(rowData.handledBy[rowData.handledBy.length - 1]?.handledDate).format("DD-MM-YYYY")}</p>
                                    </>
                                )
                            }}></Column>
                            <Column
                                header="New Status"
                                field='status'
                                body={(rowData) => {
                                    const newStatus = rowData.status === 'Active' ? 'InActive' : 'Active';
                                    return (
                                        <div className={`status-badge ${newStatus.toLowerCase()}`}>
                                            {newStatus}
                                        </div>
                                    );
                                }}
                            />

                            <Column header="Reasons For Status Change" body={(rowData) => {
                                return (
                                    <>
                                        <p>{rowData.statusChangeRemarks}</p>
                                    </>
                                )
                            }}></Column>
                            <Column header="Approved By" body={(rowData) => {
                                return (
                                    <>
                                        <p>{(rowData.handledBy[rowData.handledBy.length - 1]?.userName).slice(3)}</p>
                                    </>
                                )
                            }}></Column>

                        </DataTable>
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </>

        )
    }
}
const mapStatesToProps = (state) => ({
    isLoading: state.boardsData.loading,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data?.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._idF
});
export default connect(mapStatesToProps, { getBranchesLatest })(Authentication(withRouter(StudentStatusChangeReport)));